function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.5 15.8C37.3284 15.8 38 15.1285 38 14.3C38 13.4716 37.3284 12.8 36.5 12.8C35.6716 12.8 35 13.4716 35 14.3C35 15.1285 35.6716 15.8 36.5 15.8Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38 5.1C38 2.3 35.7 0 32.9 0H5.4C2.4 0 0 2.4 0 5.4V32.6C0 35.6 2.4 38 5.4 38H32.6C35.6 38 38 35.6 38 32.6V20.6V20.5C38 20.4 38 20.3 38 20.3C38 19.5 37.3 18.8 36.5 18.8C35.7 18.8 35 19.5 35 20.3C35 20.3 35 20.3 35 20.4C35 20.5 34.9 20.6 34.9 20.7V32.7C34.9 34 33.8 35.1 32.5 35.1H5.4C4.1 35 3 33.9 3 32.6V5.4C3 4.1 4.1 3 5.4 3H32.9C34 3 35 4 35 5.1V8.8C35 8.9 35 9 35.1 9.1C35.2 9.8 35.8 10.3 36.5 10.3C37.3 10.3 38 9.6 38 8.8V5.1Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2012 28.4C21.2012 29.2 21.9012 29.9 22.7012 29.9C23.5012 29.9 24.2012 29.2 24.2012 28.4V19.6C24.2012 18.8 23.5012 18.1 22.7012 18.1C21.9012 18.1 21.2012 18.8 21.2012 19.6V28.4Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.40039 28.4C7.40039 29.2 8.10039 29.9 8.90039 29.9C9.70039 29.9 10.4004 29.2 10.4004 28.4V15.6C10.4004 14.8 9.70039 14.1 8.90039 14.1C8.10039 14.1 7.40039 14.8 7.40039 15.6V28.4Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3008 28.4C14.3008 29.2 15.0008 29.9 15.8008 29.9C16.6008 29.9 17.3008 29.2 17.3008 28.4V9.59998C17.3008 8.79998 16.6008 8.09998 15.8008 8.09998C15.0008 8.09998 14.3008 8.79998 14.3008 9.59998V28.4Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5996 29.9C30.428 29.9 31.0996 29.2285 31.0996 28.4C31.0996 27.5716 30.428 26.9 29.5996 26.9C28.7712 26.9 28.0996 27.5716 28.0996 28.4C28.0996 29.2285 28.7712 29.9 29.5996 29.9Z"
});

function SvgStatistic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.bf835893.svg";
export { ForwardRef as ReactComponent };